import {
  CartMissingActivityTicket,
  GetBasketResume,
  GetBasketWithUser,
  GetUserBasket,
} from "@ac-expo/api-types";
import { BasketType } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { basketQueryKeys } from "../query-keys/basket.query-keys";
import { useMyUserQuery } from "./user.queries";

async function getUserBasket(type: BasketType) {
  const { data } = await privateAxios.get<GetUserBasket>("/basket", {
    params: { type },
  });
  return data;
}

export function useGetUserBasket(type: BasketType) {
  const { data: user } = useMyUserQuery();

  return useQuery({
    queryKey: basketQueryKeys.get(type),
    queryFn: () => getUserBasket(type),
    enabled: user?.id !== undefined,
  });
}

async function getHasCartWarning() {
  const { data } = await privateAxios.get<CartMissingActivityTicket>(
    "/basket/activity-warning"
  );
  return data;
}

export function useGetHasCartWarning() {
  return useQuery({
    queryKey: basketQueryKeys.activityWarning(),
    queryFn: () => getHasCartWarning(),
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}

async function getAllBaskets() {
  const { data } = await privateAxios.get<GetBasketResume[]>("/basket/all");
  return data;
}

export function useGetAllBaskets() {
  return useQuery({
    queryKey: basketQueryKeys.all,
    queryFn: () => getAllBaskets(),
  });
}

async function getBasketById(id: string) {
  const { data } = await privateAxios.get<GetBasketWithUser>(`/basket/${id}`);
  return data;
}

export function useGetBasketById(id: string) {
  return useQuery({
    queryKey: basketQueryKeys.getById(id),
    queryFn: () => getBasketById(id),
  });
}
